"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OutlinedInput_1 = require("@mui/material/OutlinedInput");
const Palette_1 = require("./Palette");
const { input, inputSizeSmall, root, multiline, notchedOutline, disabled, adornedStart, focused, error } = OutlinedInput_1.outlinedInputClasses;
const MuiOutlineInputOverrides = {
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                borderRadius: '4px',
                lineHeight: '1.5rem',
                '& legend': {
                    transition: 'unset',
                },
                [`& .${input}`]: {
                    padding: '16px 12px',
                    height: '1.5rem',
                    [`&.${inputSizeSmall}`]: {
                        padding: '8px 12px',
                    },
                },
                [`&.${root}.${multiline}`]: {
                    padding: '16px 12px',
                },
                [`&:not(.${disabled}):hover .${notchedOutline}`]: {
                    border: `1px solid ${Palette_1.gray[900]}`,
                },
                [`& .${notchedOutline}`]: {
                    border: `1px solid ${Palette_1.gray[500]}`,
                    [`&.${adornedStart} svg`]: {
                        fill: Palette_1.gray[800],
                        opacity: 1,
                    },
                },
                [`&.${disabled}`]: {
                    color: Palette_1.gray[500],
                    [`&.${adornedStart} svg`]: {
                        fill: Palette_1.gray[400],
                        opacity: 1,
                    },
                    [`& .${notchedOutline}`]: {
                        border: `1px solid ${Palette_1.gray[300]}`,
                    },
                    [`&:hover .${notchedOutline}`]: {
                        border: `1px solid ${Palette_1.gray[300]}`,
                    },
                },
                [`&.${focused}`]: {
                    [`& .${notchedOutline}`]: {
                        border: `2px solid ${Palette_1.blue[500]}`,
                    },
                    [`&:hover .${notchedOutline}`]: {
                        border: `2px solid ${Palette_1.blue[500]}`,
                    },
                },
                [`&.${error}`]: {
                    [`& .${notchedOutline}`]: {
                        border: `1px solid ${Palette_1.red[500]}`,
                    },
                    [`&.${focused} .${notchedOutline}`]: {
                        border: `2px solid ${Palette_1.red[500]}`,
                    },
                    [`&:not(.${focused}):hover .${notchedOutline}`]: {
                        border: `1px solid ${Palette_1.red[500]}`,
                    },
                },
            },
            adornedStart: {
                paddingLeft: '12px',
                [`& .${input}`]: {
                    [`&.${inputSizeSmall}`]: {
                        padding: '8px 12px 8px 0',
                    },
                },
            },
        },
    },
};
exports.default = MuiOutlineInputOverrides;
//# sourceMappingURL=MuiOutlineInputOverrides.js.map